module.exports = __webpack_public_path__ + "static/04-7806189db01392bca2bb4dcd40f13ffa.jpg";